import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import OrderSlipCard from "./../OrderSlipCard";
import PaymentInformationCard from "./Information/PaymentInformationCard";
import PaymentMethodInformation from "./Information/PaymentMethodInformation";
import { _DecryptService } from "../../../service/EncryptDecryptService";
import _JWTDecodeService from "../../../service/JWTDecodeService";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";

const PaymentMethodComponents = ({ history, formData, total }) => {
  const [chooseMethod, setChooseMethod] = useState(false);
  const [selectedTownship, setSelectedTownship] = useState("");
  const [contact, setContact] = useState("");
  const [fullName, setFullName] = useState("");
  const [address, setAddress] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [data, setData] = useState({});
  const [promoCode, setPromoCode] = useState("");
  const [discount, setDiscount] = useState("");

  const addDetailsToFormData = () => {
    const token = sessionStorage.getItem("token");
    let businessName = "";
    if (token) {
      try {
        businessName = _DecryptService(
          _JWTDecodeService(_DecryptService(token)).BusinessName
        );
      } catch (error) {
        console.error("Unable to decode token for business name:", error);
      }
    }
    if (!businessName) {
      if (Array.isArray(formData) && formData[0]?.businessName) {
        businessName = formData[0].businessName;
      } else if (formData?.businessName) {
        businessName = formData.businessName;
      }
    }

    if (formData && formData.length > 0) {
      const updatedFormData = formData.map((item) => ({
        CartId: item.cartId,
        UserId: item.userId,
        BusinessName: businessName,
        ProductCode: item.productCode,
        ProductId: item.productId,
        ProductName: item.productName,
        Unit:
          item.Unit ||
          item.unit ||
          item.UnitTitle ||
          item.unitTitle ||
          item.unit,
        UnitPrice: item.unitPrice,
        Quantity: item.quantity,
        Amount: item.Amount,
        FullName: fullName,
        Email: contact,
        Phone: phoneNumber,
        ShippingTownship: selectedTownship,
        Address: address,
        Size: item.size,
        Color: item.color,
        Materials: item.materials
      }));
      setData(updatedFormData);
    } else {
      const updatedFormData = [
        {
          CartId: formData.cartId || null,
          UserId: formData.userId,
          BusinessName: businessName,
          ProductCode: formData.productCode,
          ProductId: formData.productId,
          ProductName: formData.productName,
          Unit:
            formData.Unit ||
            formData.unit ||
            formData.UnitTitle ||
            formData.unitTitle ||
            formData.unit,
          UnitPrice: formData.unitPrice,
          Quantity: formData.quantity,
          Color: formData.color,
          Size: formData.size,
          Materials: formData.materials,
          Amount: formData.Amount,
          FullName: fullName,
          Email: contact,
          Phone: phoneNumber,
          ShippingTownship: selectedTownship,
          Address: address
        },
      ];
      setData(updatedFormData);
    }
  };
  useEffect(() => {
    if (chooseMethod) {
      addDetailsToFormData();
    }
  }, [chooseMethod]);

  useEffect(() => {
    const token=sessionStorage.getItem('token');
    if (!token) {
      return;
    }
    try {
      const decodeToken=_JWTDecodeService(_DecryptService(token));
      console.log(decodeToken);
      setFullName(_DecryptService(decodeToken.UserName));
      setContact(_DecryptService(decodeToken.Email));
      setPhoneNumber(_DecryptService(decodeToken.PhoneNumber));
      setAddress(_DecryptService(decodeToken.Address));
    } catch (error) {
      console.error("Unable to decode token for user details:", error);
    }
  },[])

  return (
    <Box
      sx={{
        width: "100%",
        height: "auto",
        display: "flex",
        justifyContent: "center",
        marginBottom: "20px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          width: "80%",
          flexDirection: "row",
          gap: "250px",
        }}
      >
        <Box
          sx={{
            width: "50%",
          }}
        >
          <Box
            sx={{
              width: "100%",
              maxWidth: "600px",
              margin: "0 auto",
              padding: "20px",
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              borderRight: "1px solid #CCCCCC",
              paddingRight: "150px",
            }}
          >
            <Typography sx={{ width: "80%" }}>
              {chooseMethod && (
                <IconButton onClick={() => setChooseMethod(false)}>
                  <ArrowBackIosIcon />
                </IconButton>
              )}
              Cart {">"} Information {">"} Payment Method
            </Typography>

            {chooseMethod ? (
              <PaymentMethodInformation
                selectedTownship={selectedTownship}
                formData={data}
                promoCode={promoCode}
                discountAmount={discount}
              />
            ) : (
              <PaymentInformationCard
                setChooseMethod={setChooseMethod}
                setSelectedTownship={setSelectedTownship}
                contact={contact}
                setContact={setContact}
                phoneNumber={phoneNumber}
                setPhoneNumber={setPhoneNumber}
                address={address}
                setAddress={setAddress}
                fullName={fullName}
                setFullName={setFullName}
              />
            )}
          </Box>
        </Box>

        {chooseMethod && (
          <OrderSlipCard
            total={total}
            promoCode={promoCode}
            setPromoCode={setPromoCode}
            discount={discount}
            setDiscount={setDiscount}
          />
        )}
      </Box>
    </Box>
  );
};

export default PaymentMethodComponents;
